export interface WorkspaceIdentity {
  id: number;
}

export function selectRestoredWorkspace<T extends WorkspaceIdentity>(
  workspaces: readonly T[],
  storedWorkspaceId: number | null,
): T | null {
  return workspaces.find((workspace) => workspace.id === storedWorkspaceId)
    ?? workspaces[0]
    ?? null;
}

export function clearTokenOnUnauthorized(error: unknown, clearToken: () => void): boolean {
  if (!error || typeof error !== 'object' || !('status' in error) || error.status !== 401) {
    return false;
  }

  clearToken();

  return true;
}
